module.exports = __webpack_public_path__ + "img/258.47af6232.png";